import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Ruler, Check, Clock } from 'lucide-react';
import UnitInput from './UnitInput';
import { imperial, depU, depToM } from '../lib/units';
import { buzz } from '../lib/glove';

// after a pipe is drawn: ask laying depth (cm / in); mandatory or "later" per setting
const REQ = 'giss_depth_req';
export const depthRequired = () => localStorage.getItem(REQ) === '1';
export const setDepthRequired = (v) => { localStorage.setItem(REQ, v ? '1' : '0'); window.dispatchEvent(new Event('giss-depth-req')); };
export const askDepth = (pipeId) => window.dispatchEvent(new CustomEvent('giss-depth-ask', { detail: pipeId }));

export function DepthReqToggle({ t, testid }) {
  const [on, setOn] = useState(depthRequired);
  useEffect(() => { const f = () => setOn(depthRequired()); window.addEventListener('giss-depth-req', f); return () => window.removeEventListener('giss-depth-req', f); }, []);
  return <label className="vs-toggle"><input type="checkbox" data-testid={testid} checked={on} onChange={() => setDepthRequired(!on)} /><span><b>{t.dpReq}</b><br /><small className="muted">{t.dpReqD}</small></span></label>;
}

export default function DepthPrompt({ t, project, updateProject }) {
  const [id, setId] = useState(null);
  const [v, setV] = useState('');
  useEffect(() => { const on = (e) => { setId(e.detail); setV(''); }; window.addEventListener('giss-depth-ask', on); return () => window.removeEventListener('giss-depth-ask', on); }, []);
  const pipe = id && project?.pipes.find((p) => p.id === id);
  if (!pipe) return null;
  const req = depthRequired(), chips = imperial() ? [24, 30, 36, 48, 60] : [60, 80, 100, 120, 150];
  const ok = +v > 0 && +v <= 30;
  const save = (m) => { updateProject((p) => ({ ...p, pipes: p.pipes.map((x) => (x.id === id ? { ...x, depth: m } : x)) })); buzz(45); setId(null); };
  return createPortal(
    <div className="editor-backdrop" data-testid="depth-prompt">
      <div className="editor dp-card">
        <h4><Ruler size={18} /> {t.dpTitle}</h4>
        <p className="muted">{pipe.name} · {t['type_' + pipe.type]}</p>
        <label className="dp-in">{t.dpLabel} ({depU()})<UnitInput kind="dep" testid="depth-prompt-input" value={v} autoFocus onChange={setV} /></label>
        <div className="dp-chips">{chips.map((c) => <button key={c} type="button" className="chip seg" data-testid={`depth-chip-${c}`} onClick={() => save(depToM(c))}>{c} {depU()}</button>)}</div>
        <small className="muted">{t.dpHint}</small>
        <div className="row">
          <button className="btn btn-green" data-testid="depth-prompt-save" disabled={!ok} onClick={() => save(+v)}><Check size={16} /> {t.dpSave}</button>
          {!req && <button className="btn btn-outline" data-testid="depth-prompt-later" onClick={() => setId(null)}><Clock size={16} /> {t.dpLater}</button>}
        </div>
        {req && <small className="wl-due" data-testid="depth-prompt-required">{t.dpReqNote}</small>}
      </div>
    </div>,
    document.body,
  );
}
